import React from 'react';
import styled, { StyledComponentClass } from 'styled-components';
import { Size } from '../../types';
import { colors, globals } from '../../styles';
import { Icon } from '../../atoms/icons';

export interface Props {
  className?: string;
  placeholder?: string;
  value?: string;
  autoFocus?: boolean;
  onChange?: (e?: any) => void;
  iconSize?: Size;
  iconColor?: any;
  id?: string;
  autoComplete?: string;
}

class SearchInput extends React.Component<Props> {
  public static defaultProps: Partial<Props> = {
    placeholder: 'Search',
    autoFocus: false,
    autoComplete: 'on',
  };

  public render() {
    const {
      className,
      placeholder,
      value,
      id,
      iconSize,
      iconColor,
      onChange,
      autoFocus,
      autoComplete,
    } = this.props;
    return (
      <div className={className}>
        <label htmlFor={id}>
          <Icon
            className="search-icon"
            baseColor={iconColor}
            icon="search"
            size={iconSize || 'sm'}
          />
        </label>
        <input
          type="text"
          id={id}
          autoFocus={autoFocus}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          autoComplete={autoComplete}
        />
      </div>
    );
  }
}

const StyledSearchInput = styled(SearchInput)`
  align-items: center;
  display: flex;
  width: 100%;
  position: relative;

  label {
    display: flex;
    position: absolute;
    left: 0.5rem;
    top: 0;
    padding: 0.5rem 0;
  }

  input {
    ${globals.input};

    border-radius: 2.25em;
    box-shadow: 0 0 0 1px ${colors.grey300};
    padding: 0.625em 0.625em 0.625em 2.5em;
    transition: box-shadow 150ms ease;
    width: 100%;

    &::placeholder {
      color: ${colors.grey500};
    }

    &:focus {
      box-shadow: 0 0 0 1px ${colors.blue400};
    }
  }
`;

export default StyledSearchInput;
